import apiClient from "../apiClient";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageContext from "../PageContext.jsx";

const BanksUpdate = () => {
    const [currencies, setCurrencies] = useState([]);
    const [bank, setBank] = useState({
        Description: "",
        CurrencyID: "",
        AnnualInterestRate: "0.00",
        IsRetirement: 0,
    });

    const [error, setError] = useState(false);
    const sortedCurrencies = useMemo(
        () => [...currencies].sort((a, b) => (a.Description || "").localeCompare(b.Description || "")),
        [currencies]
    );

    const navigate = useNavigate();
    const location = useLocation();
    const bankId = location.pathname.split("/")[2];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [bankRes, currenciesRes] = await Promise.all([
                    apiClient.get("/banks"),
                    apiClient.get("/currencies"),
                ]);
                const currenciesRows = Array.isArray(currenciesRes.data) ? currenciesRes.data : [];
                const sorted = [...currenciesRows].sort((a, b) => (a.Description || "").localeCompare(b.Description || ""));
                setCurrencies(sorted);

                const banksRows = Array.isArray(bankRes.data) ? bankRes.data : [];
                const selectedBank = banksRows.find((item) => String(item.BankID) === String(bankId));
                if (selectedBank) {
                    setBank({
                        Description: selectedBank.Description || "",
                        CurrencyID:
                            selectedBank.CurrencyID ||
                            currenciesRows.find((row) => Number(row.IsDefault))?.CurrencyID ||
                            sorted[0]?.CurrencyID ||
                            "",
                        AnnualInterestRate: selectedBank.AnnualInterestRate != null ? String(selectedBank.AnnualInterestRate) : "0.00",
                        IsRetirement: Number(selectedBank.IsRetirement || 0),
                    });
                } else if (sorted.length > 0) {
                    setBank((prev) => ({
                        ...prev,
                        CurrencyID: currenciesRows.find((row) => Number(row.IsDefault))?.CurrencyID || sorted[0].CurrencyID,
                    }));
                }
            } catch (err) {
                setError(true);
            }
        };
        fetchData();
    }, [bankId]);

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setBank((prev) => ({ ...prev, [name]: type === "checkbox" ? (checked ? 1 : 0) : value }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        if (!bank.Description?.trim() || !bank.CurrencyID) return setError(true);
        try {
            await apiClient.put(`/banks/${bankId}`, bank);
            navigate("/Banks");
        } catch (err) {
            setError(true);
        }
    };

    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Update Bank</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Banks">Banks</Link> / Update</p>
                </div>
            </header>
            <PageContext
                items={[
                    { label: "Home", to: "/" },
                    { label: "Banks", to: "/Banks" },
                    { label: "Update Bank" },
                ]}
                note={bank.Description ? `Editing ${bank.Description}.` : "Update the selected bank account."}
            />
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="bank-description">Bank Description</label>
                    <input
                        id="bank-description"
                        type="text"
                        placeholder="Bank Description"
                        name="Description"
                        value={bank.Description}
                        onChange={handleChange}
                    />
                    <label htmlFor="bank-currency">Currency</label>
                    <select id="bank-currency" name="CurrencyID" onChange={handleChange} value={bank.CurrencyID}>
                        {sortedCurrencies.map((currency) => (
                            <option key={currency.CurrencyID} value={currency.CurrencyID}>
                                {currency.Description}
                            </option>
                        ))}
                    </select>
                    <label htmlFor="bank-interest-rate">Annual Interest Rate (%)</label>
                    <input
                        id="bank-interest-rate"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="e.g. 8.50"
                        name="AnnualInterestRate"
                        value={bank.AnnualInterestRate}
                        onChange={handleChange}
                    />
                    <label className="checkbox-row">
                        <input
                            type="checkbox"
                            name="IsRetirement"
                            checked={Boolean(bank.IsRetirement)}
                            onChange={handleChange}
                        />
                        <span>Retirement bank</span>
                    </label>
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Update Bank</button>
                        <Link className="btn-link" to="/Banks">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not update bank. Check input and try again.</p>}
                </div>
            </section>
        </div>
    );
};

export default BanksUpdate;
